/**
 * Fix for JavaScript errors in the theme
 * - Fixes "null is not an object (evaluating 'this.stickyutils.style')"
 * - Fixes "Cannot read properties of null (reading 'classList')" at line 36704
 */
(function() {
  // Global error handler for all classList errors
  window.addEventListener('error', function(event) {
    // Check if the error is related to classList
    if (event.error && event.error.message && 
        event.error.message.indexOf("Cannot read properties of null (reading 'classList')") !== -1) {
      // Prevent the error from propagating
      event.preventDefault();
      event.stopPropagation();
      console.warn('Prevented classList error:', event.error.message);
      
      return true; // Indicates we've handled the error
    }
  }, true); // Capture phase to intercept before other handlers
  
  // Direct patch for document.body.classList.add
  const originalBodyClassListAdd = document.body.classList.add;
  document.body.classList.add = function() {
    try {
      return originalBodyClassListAdd.apply(this, arguments);
    } catch (e) {
      console.warn('Prevented error in body.classList.add:', e.message);
    }
  };
  
  // When DOM is loaded, apply specific fixes
  document.addEventListener('DOMContentLoaded', function() {
    // Initial fixes for anything already in the DOM
    applyFixes();
    
    // Wait to ensure all scripts are loaded
    setTimeout(applyFixes, 500);
    setTimeout(applyFixes, 1500);
    setTimeout(applyFixes, 3000);
  });
  
  // Fixes to apply multiple times to catch elements as they're added
  function applyFixes() {
    // Fix for the hideFilterIfMobile function
    patchHideFilterIfMobile();
    
    // Fix for stickyUtils
    patchProductGridUtils();
  }
  
  // Specific patch for the hideFilterIfMobile function
  function patchHideFilterIfMobile() {
    // Fix for SearchForm constructor
    if (typeof window.SearchForm === 'function') {
      try {
        // Save original
        const originalSearchForm = window.SearchForm;
        
        // Create a safer version
        window.SearchForm = function() {
          try {
            // Call original constructor
            const result = originalSearchForm.apply(this, arguments);
            
            // If hideFilterIfMobile was defined inside the constructor
            if (this.hideFilterIfMobile) {
              const originalHideFilter = this.hideFilterIfMobile;
              
              // Replace with safe version
              this.hideFilterIfMobile = function() {
                try {
                  // Check if form exists
                  if (!this.form) return;
                  
                  if (Layout.isLessThanBreakpoint('S')) {
                    if (this.filter) {
                      this.filter.value = '';
                    }
                    
                    if (this.form && this.form.classList) {
                      this.form.classList.remove('live-search-filter-active');
                    }
                    
                    if (this.filterLabel && this.filter && this.filter.dataset) {
                      this.filterLabel.innerHTML = this.filter.dataset.filterAll;
                    }
                  }
                } catch (e) {
                  console.warn('Prevented error in hideFilterIfMobile:', e.message);
                }
              };
            }
            
            return result;
          } catch (e) {
            console.warn('Error in SearchForm constructor:', e.message);
            return {};
          }
        };
        
        // Preserve prototype chain
        window.SearchForm.prototype = originalSearchForm.prototype;
        window.SearchForm.prototype.constructor = window.SearchForm;
      } catch (e) {
        console.warn('Error patching SearchForm:', e.message);
      }
    }
    
    // Patch any existing instances in the DOM
    try {
      // Find all search forms
      document.querySelectorAll('[data-live-search-form]').forEach(function(form) {
        const parent = form.closest('[data-live-search]');
        
        if (parent) {
          // 1. Directly patch the hideFilterIfMobile function if it exists
          if (typeof parent.hideFilterIfMobile === 'function') {
            const original = parent.hideFilterIfMobile;
            
            parent.hideFilterIfMobile = function() {
              try {
                if (!this.form) return;
                return original.apply(this, arguments);
              } catch (e) {
                console.warn('Prevented error in existing hideFilterIfMobile:', e.message);
              }
            };
          }
          
          // 2. Add safety checks directly to form and filter objects
          if (parent.form && parent.form.classList) {
            const originalRemove = parent.form.classList.remove;
            
            parent.form.classList.remove = function() {
              try {
                return originalRemove.apply(this, arguments);
              } catch (e) {
                console.warn('Prevented error in form.classList.remove:', e.message);
              }
            };
          }
        }
      });
    } catch (e) {
      console.warn('Error applying fixes to existing search forms:', e.message);
    }
    
    // Patch Layout.onBreakpointChange to catch callbacks
    if (typeof Layout !== 'undefined' && Layout.onBreakpointChange) {
      try {
        const originalOnBreakpointChange = Layout.onBreakpointChange;
        
        Layout.onBreakpointChange = function(callback) {
          // If this is likely our problematic function
          if (callback && callback.toString().includes('this.form.classList')) {
            // Return a safer version
            return originalOnBreakpointChange.call(this, function() {
              try {
                if (!this.form) return;
                return callback.apply(this, arguments);
              } catch (e) {
                console.warn('Prevented error in breakpoint change callback:', e.message);
              }
            });
          }
          
          // Otherwise use original callback but wrap in try/catch
          return originalOnBreakpointChange.call(this, function() {
            try {
              return callback.apply(this, arguments);
            } catch (e) {
              console.warn('Prevented error in breakpoint callback:', e.message);
            }
          });
        };
      } catch (e) {
        console.warn('Error patching Layout.onBreakpointChange:', e.message);
      }
    }
  }
  
  // Patch for product grid utils
  function patchProductGridUtils() {
    if (typeof Layout !== 'undefined' && Layout.sections) {
      try {
        Layout.sections.forEach(function(section) {
          if (section && section.instance) {
            // Patch _initProductGridUtils
            if (typeof section.instance._initProductGridUtils === 'function') {
              const originalMethod = section.instance._initProductGridUtils;
              
              section.instance._initProductGridUtils = function() {
                try {
                  // Check if required elements exist
                  if (!this.stickyUtils || !this.stickyUtilsIntersectionTarget) {
                    return;
                  }
                  
                  return originalMethod.apply(this, arguments);
                } catch (e) {
                  console.warn('Prevented error in _initProductGridUtils:', e.message);
                }
              };
            }
            
            // Patch _observeHeaders
            if (typeof section.instance._observeHeaders === 'function') {
              const originalMethod = section.instance._observeHeaders;
              
              section.instance._observeHeaders = function() {
                try {
                  // Check if required element exists
                  const intersectionTarget = document.querySelector('[data-utils-intersection-target]');
                  if (!intersectionTarget) {
                    return;
                  }
                  
                  return originalMethod.apply(this, arguments);
                } catch (e) {
                  console.warn('Prevented error in _observeHeaders:', e.message);
                }
              };
            }
          }
        });
      } catch (e) {
        console.warn('Error patching product grid utils:', e.message);
      }
    }
  }
})(); 